module.exports = __webpack_public_path__ + "static/media/dino.af6ee5de.png";